import { HistogramToolbarSlotProps } from '../types/toolbar.js';

/**
 * Slot for configuring the toolbar within a HistogramChart.
 * @public
 */
export const Toolbar = (props: HistogramToolbarSlotProps) => null;

Toolbar.displayName = 'HistogramChart.Toolbar';
